<template>
  <b-card title="Histórico">

    <div v-if="loading" class="text-center py-3">
      <b-spinner label="Carregando..." />
      <p>Aguarde, isso pode levar alguns instantes...</p>
    </div>

   <b-table
      v-else-if="formattedItems.length > 0"
      striped
      :per-page="perPage"
      :current-page="currentPage"
      hover
      :items="formattedItems"
      :fields="fields"
    />

    <div v-else class="text-center py-4 text-muted">
      Nenhum registro encontrado
    </div>
    <b-pagination
      v-model="currentPage"
      :total-rows="items.length"
      :per-page="perPage"
      align="center"
      class="mt-3"
    />

  </b-card>
</template>

<script>
import {
  BCard,
  BTable,
  BPagination,
  BSpinner,
} from "bootstrap-vue";

import { DateTime } from "luxon";

export default {
  components: {
    BCard,
    BTable,
    BPagination,
    BSpinner,
  },

  props: {
    items: {
      type: Array,
      default: () => []
    },
    loading: Boolean,
  },

  data() {
    return {
      currentPage: 1,
      perPage:10,
      fields: [
        { key: "merchant_name", label: "Nome PV", sortable: true  },
        { key: "legal_name", label: "Razão Social", sortable: true  },
        { key: "category", label: "Categoria" },
        { key: "document", label: "CPF/CNPJ" },
        { key: "date", label: "Data", sortable: true  },
        { key: "cancellation_reason", label: "Motivo" },
      ],
    };
  },

 computed: {
  formattedItems() {
    return this.items.map((item) => ({
      merchant_name: item.merchant_name || "-",
      legal_name: item.legal_name || "-",
      category: item.category || "-",
       document: this.formatDocument(item.document) || "-",
      date: item.date
        ? DateTime.fromISO(item.date).toFormat("dd/MM/yyyy")
        : "-",
      cancellation_reason: item.cancellation_reason || "-",
    }));
  },
},

  methods: {
     formatDocument(value) {
      const numbers = String(value).replace(/\D/g, '');

      if (numbers.length === 11) {
        return numbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      } else if (numbers.length === 14) {
        return numbers.replace(
          /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          '$1.$2.$3/$4-$5'
        );
      }
      return value; 
    }
  },
};
</script>